import { Edit3, ExternalLink } from 'lucide-react';
import { Reservation } from '../../../../types/restaurant/RestaurantReservationTypes';

interface Props {
  reservation: Reservation;
  arrivalWindowOpen: boolean;
  onEdit: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  onNoShow: () => void;
  onOpenOrder: () => void;
}

const ReservationActions = ({
  reservation,
  arrivalWindowOpen,
  onEdit,
  onConfirm,
  onCancel,
  onNoShow,
  onOpenOrder,
}: Props) => {
  const editable = ['PENDING', 'CONFIRMED'].includes(reservation.status);
  const hasOrder =
    ['SEATED', 'COMPLETED'].includes(reservation.status) && reservation.orderId;
  return (
    <div className="flex flex-wrap justify-end gap-2">
      {editable && (
        <button
          onClick={onEdit}
          className="inline-flex items-center gap-1.5 rounded-lg border border-stroke px-3 py-2 text-xs font-semibold text-black hover:border-primary hover:text-primary dark:border-strokedark dark:text-white"
        >
          <Edit3 className="h-3.5 w-3.5" />
          Editar
        </button>
      )}
      {reservation.status === 'PENDING' && (
        <button
          onClick={onConfirm}
          className="rounded-lg bg-success px-3 py-2 text-xs font-semibold text-white"
        >
          Confirmar
        </button>
      )}
      {editable && (
        <button
          onClick={onCancel}
          className="rounded-lg border border-danger px-3 py-2 text-xs font-semibold text-danger"
        >
          Cancelar
        </button>
      )}
      {reservation.status === 'CONFIRMED' && (
        <button
          onClick={onNoShow}
          className="rounded-lg border border-warning px-3 py-2 text-xs font-semibold text-meta-8"
        >
          No-show
        </button>
      )}
      {reservation.status === 'CONFIRMED' && arrivalWindowOpen && (
        <button
          onClick={onOpenOrder}
          className="inline-flex items-center gap-1.5 rounded-lg bg-primary px-3 py-2 text-xs font-semibold text-white"
        >
          <ExternalLink className="h-3.5 w-3.5" />
          Recibir / Abrir orden
        </button>
      )}
      {hasOrder && (
        <button
          onClick={onOpenOrder}
          className="inline-flex items-center gap-1.5 rounded-lg bg-primary px-3 py-2 text-xs font-semibold text-white"
        >
          <ExternalLink className="h-3.5 w-3.5" />
          Ir a orden
        </button>
      )}
    </div>
  );
};

export default ReservationActions;
